"use client";

import {useTranslation} from "react-i18next";
import SendButton from "../SendButton";

type SendOrStopButtonProps = Readonly<{
   isSubmitting: boolean;
   onCancelStream?: () => void;
   canSubmit: boolean;
   loading: boolean;
   sendTooltip?: string;
}>;

/** Send becomes a stop button while a cancellable stream is in flight. */
export default function SendOrStopButton({
   isSubmitting,
   onCancelStream,
   canSubmit,
   loading,
   sendTooltip,
}: SendOrStopButtonProps) {
   const {t: ct} = useTranslation("common");

   if (isSubmitting && onCancelStream) {
      return (
         <SendButton
            type="button"
            icon="stop"
            variant="stop"
            onClick={onCancelStream}
            ariaLabel={ct("stopGenerating")}
            className="shrink-0"
         />
      );
   }

   return (
      <SendButton
         disabled={!canSubmit}
         loading={loading}
         className="shrink-0"
         tooltip={sendTooltip}
      />
   );
}
